<template>
  <div class="relative flex flex-col justify-start items-center h-full">
    <div class="w-full h-1/6 lg:h-1/10"></div>
    <section-title titlePath="title-8.png" />
    <div class="btns flex flex-row justify-center w-full mb-5">
      <div
        v-for="(menu, index) in menuData"
        :key="index"
        :class="{ menuActive: menu.isActive }"
        class="cursor-pointer w-226 h-78 m-3 text-white font-elmessiri text-xl flex justify-center items-center bg-auto bg-btn bg-10-10 hover:bg-10-108"
        @click="handleMenu(index)"
      >
        {{ menu.text }}
      </div>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="relative w-full h-560 flex justify-center items-start"
    >
      <div
        v-show="menuData[0].isActive"
        class="absolute w-full max-w-810 flex flex-col items-center lg:max-w-538"
        :key="menuData[0].text"
      >
        <div class="w-full max-w-790">
          <img :src="`${imgPath}/slide9/img_runestones.png`" />
        </div>
        <div class="font-nunito text-grayish-orange text-center lg:max-w-full">
          Customize your character like never before with the aspirational
          Runestones and Memorials.
          <br />
          Runestones are magical stones that provide additional stat boosts
          based on your chosen class. You can have up to 5 Runestones active,
          with more available Runestones being unlocked as you level up.
          <br />
          Each of your Runestones is randomly chosen from a pool of up to 30
          possible Runestone types, with each type providing its own special
          benefit; if you are unhappy with your Runestone type selection,<br />
          you can re-roll all of them at any time for a Runestone Scroll
          purchased from NPC Rohan or flash sales.
        </div>
      </div>
      <div
        v-show="menuData[1].isActive"
        class="absolute w-full max-w-810 h-464 flex flex-col items-center lg:max-w-538"
        :key="menuData[1].text"
      >
        <div
          class="w-full max-w-790 h-464 bg-memorial-sprites bg-10-10 bg-auto hover:bg-820-10 xl:bg-820-10 lg:hidden"
        ></div>
        <div class="w-full hidden lg:flex justify-center items-center">
          <img :src="`${imgPath}/slide9/img_memorials_hover.png`" />
        </div>
      </div>
    </transition-group>
    <img
      class="magic-girl absolute right-4 bottom-0 invisible lg:invisible"
      :src="`${imgPath}/slide9/9_character.png`"
    />
  </div>
</template>

<script>
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: {
    SectionTitle,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      menuData: [
        {
          text: 'Runestones',
          isActive: true,
        },
        {
          text: 'Memorials',
          isActive: false,
        },
      ],
    };
  },
  methods: {
    handleMenu: function(menuIndex) {
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuIndex === i) {
          this.menuData[i].isActive = true;
        } else {
          this.menuData[i].isActive = false;
        }
      }
    },
    init_stat_animation: function() {
      this.$store.commit('ANIMATION/INIT_STAT_SECTION_INNER');
    },
    disable_stat_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_STAT_SECTION_INNER');
    },
  },
  created: function() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.activeSection,
      (newValue, oldValue) => {
        //console.log(`Updating from ${oldValue} to ${newValue}`);
        // Do whatever makes sense now
        //console.log(this.refs);
        if (newValue === 8 && this.breakpoints.w > 1366) {
          this.init_stat_animation();
        } else if (newValue != 8 && this.breakpoints.w > 1366) {
          this.disable_stat_animation();
        }
      },
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
};
</script>

<style lang="postcss" scoped>
.btns .menuActive {
  @apply bg-10-108;
}
</style>
